export const UPLOAD_FILE = 'upload_file',
    UPLOAD_FILE_SUCCESS = 'upload_file_success',
    UPLOAD_FILE_FAIL = 'upload_file_error';